import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AgreementsPage } from "@/features/agreements/AgreementsPage";

const search = z.object({
  kind: z.enum(["msa", "sow", "nda", "change-request"]).optional(),
  type: z.string().optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/agreements/")({
  validateSearch: search,
  component: () => <AgreementsPage search={Route.useSearch()} />,
});
